export default "__VITE_ASSET__C11PWCvn__"